import { useContext } from 'react';
import ApiErrorContext from '~/context/api-error.context';
import ApiError from '~/components/common/api-error.component';

const ErrorContainer = () => {
  const { errors, handleErrorDismiss } = useContext(ApiErrorContext);

  return (
    <div className="absolute space-y-4 m-2 right-0" style={{ zIndex: 100 }}>
      {errors.map((error) => {
        return (
          <ApiError
            key={error.key}
            errorCode={error.error?.extensions?.exceptionCode?.toString()}
            onClose={() => handleErrorDismiss(error.key)}
          />
        );
      })}
    </div>
  );
};

export default ErrorContainer;
